import { render, staticRenderFns } from "./detailpayment.vue?vue&type=template&id=1f1d2aac&scoped=true&"
import script from "./detailpayment.vue?vue&type=script&lang=js&"
export * from "./detailpayment.vue?vue&type=script&lang=js&"
import style0 from "./detailpayment.vue?vue&type=style&index=0&id=1f1d2aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d2aac",
  null
  
)

export default component.exports